'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionsController = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _Subscription = require('./Subscription');

var _Subscription2 = _interopRequireDefault(_Subscription);

var _LoadMonitor = require('./LoadMonitor');

var _LoadMonitor2 = _interopRequireDefault(_LoadMonitor);

var _subscriptionStore = require('./subscriptionStore');

var _util = require('./util');

var _lodash = require('lodash');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
/**
 * SubscriptionsController is for dealing with SSR,
 * and other first/final load applications,
 * effectively bridging Subscriptions to LoadMonitor
 */


var SubscriptionsController = exports.SubscriptionsController = function () {
  function SubscriptionsController(_ref) {
    var _this = this;

    var app = _ref.app,
        onLoad = _ref.onLoad;

    _classCallCheck(this, SubscriptionsController);

    this.listen = function (query, callback) {
      var subId = (0, _util.hashObj)(query);
      var sub = _this.subscriptions[subId];

      if (!sub) {
        // console.log('💥 Creating new subscription for query', query, subId, keys(this.subscriptions))
        sub = new _Subscription2.default(_this.app.database(), query, function () {
          delete _this.subscriptions[subId];
        });
        _this.subscriptions[subId] = sub;

        if (!sub.loaded) {
          var complete = _this.loadMonitor.registerLoad();

          var _sub$listen = sub.listen(function () {
            // console.log("Callback!")
            complete();
            unsubscribe();
          }),
              unsubscribe = _sub$listen.unsubscribe;
        }
      } else {// console.log('♻️ Reusing old subscription for query', query, subId)
      }

      return sub.listen(callback);
    };

    if (!app) {
      throw new Error('No app has been defined for the Firebase Subscriptions Controller');
    }

    this.app = app;
    this.onLoad = onLoad;
    this.loadMonitor = new _LoadMonitor2.default(function () {
      _this.onLoad && _this.onLoad();
    });
    this.subscriptions = (0, _subscriptionStore.subscriptionStoreForAppName)(app.name);
  }

  _createClass(SubscriptionsController, [{
    key: 'cleanUp',
    value: function cleanUp() {
      var _this2 = this;

      (0, _lodash.forEach)(this.subscriptions, function (sub, subId) {
        if ((0, _lodash.isEmpty)(sub.listeners)) {
          sub.destroy(true);
          delete _this2.subscriptions[subId];
        }
      });
    }
  }]);

  return SubscriptionsController;
}();